// extracted by mini-css-extract-plugin
module.exports = {"video-space":"snaptix-aroma-discreet_video-space__i8Tif"};